module.exports = __webpack_public_path__ + "static/media/lautaro_dilollo.67c92704.jpg";